import React, { useEffect, useState, useCallback } from 'react';
import http from "../../config/http-common";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import LietotajsModal from './LietotajsModal'
import Modal from "react-bootstrap/Modal";

type User = {
    Id: string,
    UserId: string,
    Name_lastname: string,
    Phone: string,
    Email: string,
    Address: string,
    RegNr: string,
    Company: string,
    PvnNr: string,
    CompanyAddress: string,
    WWW: string
    Role:string
}

const Lietotaji: React.FC = () => {
    const token = localStorage.getItem('token');

    const [users, setUsers] = useState<User[]>([]);
    const [show, setShow] = useState(false);
    const [showDrosiba, setShowDrosiba] = useState(false);
    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const handleClose = () => setShow(false);
    const handleDrosibaClose = () => setShowDrosiba(false);
    const handleShow = () => setShow(true);
    const handlDrosibaeShow = () => setShowDrosiba(true);
    const navigate = useNavigate();
    const [password, setPassword] = useState<string>('');
    const [selectedRole, setSelectedRole] = useState<string>('');
    const [search, setSearch] = useState<string>('');

    const fetchData = useCallback(async () => {

        try {
            const result = await http.get('/api/users', {
                headers: {
                    'Token': token
                }
            });
            setUsers(result.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigate('/login');
            }
        }
    }, [navigate, token]);

    const updateUser = async () => {
        if (!selectedUser) return;

        const updatedUser = {
            Id: selectedUser.UserId,
            password: password,
            role: (selectedRole || selectedUser?.Role), /* Modified code: role from selectedRole state */
        };

        await http.put(`api/users/login`, updatedUser, {
            headers: {
                'Token': token
            }
        });
        setShowDrosiba(false);
        fetchData();
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleClick = (user: User) => {
        setSelectedUser(user);
        handleShow();
    };

    const handleDrosibaClick = (user: User) => {
        setSelectedUser(user);
        handlDrosibaeShow()
        setPassword('');
    }

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
    };
    const handleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedRole(e.target.value);
    };

    const handlePasswordGeneration = () => {
        const characters : string = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#$%';
        let password : string = '';
        const characterLength : number = characters.length;
        for ( let i = 0; i < 8; i++ ) {
            password += characters.charAt(Math.floor(Math.random() * characterLength));
        }
        setPassword(password);
    };

    return (
        <div className="container mt-4">
            <div className="row align-items-end">
                <div className="col-sm-6 col-md-4 col-lg-3">
                    <h2>Lietotāji</h2>
                </div>
                <div className="col-sm-6 col-md-8 col-lg-9 mt-3 mt-sm-0">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Meklēt pēc vārda, uzņēmuma, e-pasta, tālruņa vai reģ. nr."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            {users.length === 0 ? (
                <div className="alert alert-info mt-3">Nav neviena lietotāja.</div>
            ) : (
                <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3 mt-1">
                    {users
                        .filter(u => {
                            if (!search.trim()) return true;
                            const q = search.toLowerCase();
                            return (
                                (u.Company || '').toLowerCase().includes(q) ||
                                (u.Name_lastname || '').toLowerCase().includes(q) ||
                                (u.Email || '').toLowerCase().includes(q) ||
                                (u.Phone || '').toLowerCase().includes(q) ||
                                (u.RegNr || '').toLowerCase().includes(q)
                            );
                        })
                        .map((user, index) => (
                        <div className="col" key={index}>
                            <div className="card h-100 shadow-sm">
                                <div className="card-body d-flex flex-column">
                                    <div className="d-flex align-items-start mb-2">
                                        <div className="flex-grow-1">
                                            <h5 className="card-title mb-1">{user.Company || user.Name_lastname}</h5>
                                            {user.Company && (
                                                <div className="text-muted small">{user.Name_lastname}</div>
                                            )}
                                        </div>
                                    </div>
                                    <ul className="list-unstyled mb-3 small">
                                        <li><b>Reģ. Nr.:</b> {user.RegNr || '-'} </li>
                                        <li><b>E-pasts:</b> {user.Email || '-'} </li>
                                        <li><b>Tālrunis:</b> {user.Phone || '-'} </li>
                                        {user.WWW && (
                                            <li><b>WWW:</b> <a href={user.WWW.startsWith('http') ? user.WWW : `http://${user.WWW}`} target="_blank" rel="noreferrer">{user.WWW}</a></li>
                                        )}
                                    </ul>
                                    <div className="mt-auto">
                                        <button className="btn btn-outline-primary btn-sm" onClick={() => handleClick(user)}>Dati</button>
                                        <button className="btn btn-primary btn-sm ms-2" onClick={() => handleDrosibaClick(user)}>Drošība</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {selectedUser &&
            <LietotajsModal show={show} onClick={handleClose} selectedUser={selectedUser} reloadData={fetchData}/>
            }

            <Modal className="modal" show={showDrosiba} onHide={handleDrosibaClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Paroles/Lomas maiņa</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5>{selectedUser?.Company || selectedUser?.Name_lastname}</h5>
                    <hr/>
                    <div className="row">
                        <div className="col-6">
                            <input type="text" id="password" name="password" className="form-control" value={password} onChange={handlePasswordChange}/>
                        </div>
                        <div className="col-6">
                            <button className="btn btn-primary" onClick={handlePasswordGeneration}>Izveidot Paroli</button>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-4 mt-2">
                            <label><b>Lietotāja Loma:</b></label>
                        </div>
                        <div className="col-8">
                            <select
                                className="form-control"
                                id="Role"
                                name="Role"
                                value={selectedRole || selectedUser?.Role}
                                onChange={handleRoleChange}
                            >
                                <option value="user">user</option>
                                <option value="admin">admin</option>
                            </select>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={handleDrosibaClose}>Atcelt</button>
                    <button className="btn btn-primary" onClick={updateUser}>Saglabāt</button>
                </Modal.Footer>
            </Modal>

        </div>
    );
};

export default Lietotaji;